import Vue from 'vue'
import App from './App.vue'

import {store_getStateValue_vo, store_var} from "@/store";
import {http_webSocket_close_f, http_webSocket_init_f, http_initAutoTryToSendFailedRequest_fn} from "@/scripts/Server/S_HttpRequests"; // not sure why, but this line should be first
import router, {route_getCurrentFullPath_s} from './router'

import './registerServiceWorker'

import 'vue-loaders/dist/vue-loaders.css';
import { BallPulseSyncLoader } from 'vue-loaders';

// my styles
import './assets/style/Style_HtmlTags.scss'
import './assets/style/Style_Fonts.scss'
import './assets/style/Style_TqTags.scss'
import './assets/style/Style_TqClasses.scss'
import './assets/style/Style_Animation.scss'
import './assets/style/Style_Colors.scss'
import './assets/style/Style_Leaflet.scss'
import './assets/style/Style_PackagesFixes.scss'
import './assets/style/Style_GoogleMap.scss'
import './assets/style/Style_CardSlider.scss'

// directives
import "./directives"

import {enum_NODE_ENV} from "../functions/src/shareCode/Share_S_Enum";
import {FB_Error} from "../functions/src/shareCode/Share_S_Classes";
import {googleAnalytics_init, googleAnalytics_setUserId} from "./scripts/API/S_API_GoogleAnalytics";
import {date_newDate_fd} from "./scripts/S_Date";
import {serverPre_errors_set_f} from "./scripts/Server/S_ServerPre";
import {
    serverAuth_currentUserData_get_vl_fp,
    serverAuth_currentUserData_remove_vl_f
} from "./scripts/Server/S_ServerAuth";
import {navigator_getRunIn_fe} from "@/scripts/S_Navigator";

Vue.config.productionTip = false
Vue.config.ignoredElements = ['iframe'];

Vue.component('BallPulseSyncLoader', BallPulseSyncLoader);

let saveError_f = ({err, viewName_s, info}) => {
    if(process.env.NODE_ENV === enum_NODE_ENV.production) {

        let store_ongoing_questEvent_c = store_getStateValue_vo(store_var.ongoing_questEvent).val

        let error_c = new FB_Error({
            err_time_t      : date_newDate_fd().getTime(),
            err_stack_s     : err.stack,
            err_msg_s       : err.message,
            err_name_s      : err.constructor.name,
            err_viewName_s  : viewName_s,
            err_viewInfo_s  : info,
            err_userId_uid  : currentUserData_c ? currentUserData_c.ud_userId_uid : null,

            err_runIn_e     : navigator_getRunIn_fe(),
            err_fullRoute_e : route_getCurrentFullPath_s(),

            err_ongoingQuestType_e : store_ongoing_questEvent_c ? store_ongoing_questEvent_c.qev_questType_e : '',
            err_ongoingQuestId_uid : store_ongoing_questEvent_c ? store_ongoing_questEvent_c.qev_questId_uid : '',
            err_ongoingEventId_uid : store_ongoing_questEvent_c ? store_ongoing_questEvent_c.qev_eventId_uid : '',
        })

        serverPre_errors_set_f({
            error_c: error_c,
            cb_f : () =>{}
        })
    }

}

let currentUserData_c = null

// errorHandler
Vue.config.errorHandler = (err, vm, info) => {

    saveError_f({
        err         : err,
        viewName_s  : vm.$options.name,
        info        : info
    })

    throw err
}

// onerror
window.onerror = (msg, url, line, col, error) => {

    saveError_f({
        err         : error,
        viewName_s  : "window.onerror",
        info        : `${url} (${line}, ${col})`
    })
}

window.addEventListener('unhandledrejection', (e) => {
    saveError_f({
        err         : e.reason,
        viewName_s  : "unhandledrejection",
        info        : ``
    })
});


// let data = {
//     "6/rs_riddleId_n": 6,
//     "6/rs_unlock_byLockId_c/1": {
//         "rsud_lockState_e": "waitingToApprove",
//         "rsud_lockType_e": "OPTIONS",
//         "rsud_quizUserAns_byQuestionIndex_as": {
//             "0": {
//                 "0": "כ-1/4 משטח היבשה בעולם"
//             }
//         },
//         "rsud_receivedPoints_n": 10,
//         "rsud_skip_b": false,
//         "rsud_timestemp_t": 1648380474837,
//         "rsud_userId_uid": "IylgyEl19CNLZlhznWBSZ77E3El2"
//     }
// }
//
// let data_o = {}
// for(let key_s in data){
//
//     let path_as = key_s.split("/")
//
//     let currentData_o = data_o
//     path_as.forEach((path_s, index_n) => {
//         if(index_n === path_as.length - 1){
//             currentData_o[path_s] = data[key_s]
//         }else{
//             if(currentData_o[path_s] == null){
//                 currentData_o[path_s] = {}
//             }
//             currentData_o = currentData_o[path_s]
//         }
//     })
//
// }
//
// console.log(data_o)

const fileName_s ='main.js'

new Vue({
    router,
    render: h => h(App),

    // mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
    created(){

        http_webSocket_init_f()
        http_initAutoTryToSendFailedRequest_fn()

        serverAuth_currentUserData_get_vl_fp(fileName_s, (userData_c) => {

            currentUserData_c = userData_c

            if( process.env.NODE_ENV === enum_NODE_ENV.production) {
                googleAnalytics_init()
                googleAnalytics_setUserId(userData_c)
            }
        })

    },
    destroyed(){
        serverAuth_currentUserData_remove_vl_f(fileName_s)
        http_webSocket_close_f()
    }

}).$mount('#app')

